import React from "react";
import get from "lodash/get";
import { styled } from "@mui/material/styles";
import { Button, Modal } from "@mui/material";
import BSInput from "../../../common/js/components/BSInput";
import BSSelect from "../../../common/js/components/BSSelect";
import { propertyTypes } from "../types/propertyTypes";
import { us_states_options } from "../utils/constants";
import PropertyCommentBlock from "../comments/PropertyCommentBlock";

const PropertyRequestModal = (props) => {
    const { errors, handleSubmit, propertyRequestModal, updatePropertyRequest, togglePropertyRequestModal } =
        props;

    const handleUpdate = (field, value) => {
        updatePropertyRequest(field, value);
    };

    return (
        <Modal
            aria-labelledby="property-request-modal"
            aria-describedby="request-property"
            open={propertyRequestModal.open}
        >
            <PaperStyled>
                <h4 className="modal-title">Request a Property</h4>
                <React.Fragment>
                    <BSInput
                        id="propertyName"
                        label="Property Name"
                        value={propertyRequestModal.propertyName}
                        error={get(errors, `propertyName`, null)}
                        onChange={(e) => handleUpdate(e.target.id, e.target.value)}
                        placeholder="Enter property name"
                        disabled={false}
                    />
                    <BSInput
                        id="propertyAddress"
                        label="Address"
                        value={propertyRequestModal.propertyAddress}
                        error={get(errors, `propertyAddress`, null)}
                        onChange={(e) => handleUpdate(e.target.id, e.target.value)}
                        placeholder="Enter address"
                        disabled={false}
                    />
                    <CityStateZip>
                      <FlexInputWrapper>
                        <BSInput
                            id="propertyCity"
                            label="City"
                            value={propertyRequestModal.propertyCity}
                            error={get(errors, `propertyCity`, null)}
                            onChange={(e) => handleUpdate(e.target.id, e.target.value)}
                            placeholder="Enter city"
                            disabled={false}
                        />
                        </FlexInputWrapper>
                        <FlexInputWrapper>
                        <BSSelect
                            id="propertyState"
                            label="State"
                            value={propertyRequestModal.propertyState}
                            error={get(errors, `propertyState`, null)}
                            onChange={(e) => handleUpdate(e.target.id, e.target.value)}
                            placeholder="Select a state"
                            options={us_states_options}
                            disabled={false}
                        />
                        </FlexInputWrapper>
                        <FlexInputWrapper>
                        <BSInput
                            id="propertyZip"
                            label="Zip Code"
                            value={propertyRequestModal.propertyZip}
                            error={get(errors, `propertyZip`, null)}
                            onChange={(e) => handleUpdate(e.target.id, e.target.value)}
                            placeholder="Enter zip code"
                            disabled={false}
                        />
                        </FlexInputWrapper>
                    </CityStateZip>
                    <BSSelect
                        id="propertyType"
                        label="Property Type"
                        error={get(errors, `propertyType`, null)}
                        value={propertyRequestModal.propertyType}
                        onChange={(e) => handleUpdate(e.target.id, e.target.value)}
                        placeholder="Select a property type"
                        options={[
                            {
                                value: "",
                                label: "Select",
                                disabled: true,
                            },
                            ...propertyTypes,
                        ]}
                    />
                    <PropertyCommentBlock
                        errors={errors}
                        property={propertyRequestModal}
                        disableInputs={false}
                        showFormTitle={false}
                        handleInputChange={handleUpdate}
                        prefix=""
                    />
                </React.Fragment>
                <ModalButtons>
                    <div>
                        <Button variant="outlined" onClick={togglePropertyRequestModal}>
                            Cancel
                        </Button>
                    </div>
                    <div>
                        <Button variant="contained" color="primary" onClick={() => handleSubmit()}>
                            Request
                        </Button>
                    </div>
                </ModalButtons>
            </PaperStyled>
        </Modal>
    );
};

const PaperStyled = styled('div')(({ theme }) => ({
  position: 'absolute',
  width: theme.spacing(60),
  backgroundColor: theme.palette.background.paper,
  boxShadow: theme.shadows[5],
  padding: theme.spacing(3),
  borderRadius: '3px',
  '&:focus': {
    outline: 'none',
  },
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
}));

const CityStateZip = styled('div')({
    display: 'flex',
    gap: '0.25vw',
    width: '100%',
});

const ModalButtons = styled('div')({
  display: 'flex',
  gap: '0.25vw',
  justifyContent: 'flex-end',
});

const FlexInputWrapper = styled('div')({
    flex: 1,
    minWidth: 0,              // prevent overflow due to content
    boxSizing: 'border-box',  // make padding/border not exceed width
});


export default PropertyRequestModal;
